import { Form, FormActionsAlign, FormHandlers } from '@doveit/bricks';
import React from 'react';
import { jobApplicationHrUsersOptions } from '../../../job-application/constants';
import { hrRecallFormValidationSchema } from './HRRecallForm.schema';

export interface HRRecallFormModel {
  supervisorEmail: string,
  date: string,
  time: string,
  note: string,
}

export interface HRRecallFormProps extends React.AriaAttributes {
  initialValues?: Partial<HRRecallFormModel>,
  hiddenFields?: Partial<Record<keyof HRRecallFormModel, boolean>>,
  loading?: boolean,
  disabled?: boolean,
  innerRef: React.MutableRefObject<FormHandlers>,
  onSubmit: (values: HRRecallFormModel) => void,
}

export const HR_RECALL_FORM_DEFAULT_VALUES: HRRecallFormModel = {
  supervisorEmail: '',
  date: '',
  time: '',
  note: '',
};

const HRRecallForm: React.FC<HRRecallFormProps> = ({
  initialValues = {},
  loading = false,
  disabled = false,
  onSubmit,
  innerRef,
  hiddenFields,
  ...rest
}) => {
  const mergedInitialValues = React.useMemo(() => ({
    ...HR_RECALL_FORM_DEFAULT_VALUES,
    ...initialValues,
  }), [initialValues]);

  return (
    <Form
      initialValues={mergedInitialValues}
      validationSchema={hrRecallFormValidationSchema(hiddenFields)}
      innerRef={innerRef}
      onSubmit={onSubmit}
      loading={loading}
      disabled={disabled}
      {...rest}
    >
      {!hiddenFields?.supervisorEmail && (
        <Form.Item size={{ MD: 1 / 2 }}>
          <Form.Select
            name="supervisorEmail"
            label="Gestore HR"
            aria-label="Campo per specificare il gestore HR"
            options={jobApplicationHrUsersOptions}
            required
          />
        </Form.Item>
      )}

      <Form.Fieldset legend="Dettagli">
        {!hiddenFields?.date && (
          <Form.Item size={{ MD: 1 / 2 }}>
            <Form.Input
              name="date"
              type="date"
              label="Data"
              aria-label="Campo per specificare la data in cui richiamare"
              required
            />
          </Form.Item>
        )}

        {!hiddenFields?.time && (
          <Form.Item size={{ MD: 1 / 2 }}>
            <Form.Input
              label="Ora"
              type="time"
              aria-label="Campo per specificare l'ora in cui richiamare"
              name="time"
              required
            />
          </Form.Item>
        )}

        {!hiddenFields?.note && (
          <Form.Item>
            <Form.TextArea
              name="note"
              aria-label="Campo per specificare le note"
              label="Note"
              rows={6}
            />
          </Form.Item>
        )}
      </Form.Fieldset>

      {!innerRef && (
        <Form.Actions align={FormActionsAlign.RIGHT}>
          <Form.Submit label="Salva" />
        </Form.Actions>
      )}
    </Form>
  );
};

export default HRRecallForm;
